import { Routine } from 'redux-saga-routines';
import { Integration } from '../../../../common/enums/Integration';
import { INameData } from '../../../../common/models/common/INameData';
import { IWorkspaceIntegrations } from '../../../../common/models/workspace/IWorkspaceIntegrations';
import {
  disconnectFromLeverRoutine,
  getIntegrationsDataRoutine,
  getLeverStagesRoutine,
  getSurveyNamesRoutine,
  setLeverStageRoutine,
  setLeverSurveyRoutine
} from '../../routines';

export type IntegrationsState = {
  integrationsData?: IWorkspaceIntegrations;
  surveys: INameData[];
  leverStages: INameData[];
};

const initialState: IntegrationsState = { surveys: [], leverStages: [] };

export const integrations = (
  state: IntegrationsState = initialState,
  { type, payload }: Routine<any>
): IntegrationsState => {
  switch (type) {
    case getIntegrationsDataRoutine.SUCCESS:
      return {
        ...state,
        integrationsData: payload
      };
    case disconnectFromLeverRoutine.SUCCESS:
      return {
        ...state,
        integrationsData: ({ ...state.integrationsData, [Integration.Lever]: undefined })
      };
    case getLeverStagesRoutine.SUCCESS:
      return {
        ...state,
        leverStages: payload
      };
    case getSurveyNamesRoutine.SUCCESS:
      return {
        ...state,
        surveys: payload
      };
    case setLeverStageRoutine.SUCCESS:
      return {
        ...state,
        integrationsData: ({
          ...state.integrationsData,
          [Integration.Lever]: { ...state.integrationsData?.[Integration.Lever], stageId: payload }
        })
      };
    case setLeverSurveyRoutine.SUCCESS:
      return {
        ...state,
        integrationsData: ({
          ...state.integrationsData,
          [Integration.Lever]: { ...state.integrationsData?.[Integration.Lever], defaultSurveyId: payload }
        })
      };
    default:
      return state;
  }
};
